export const links = [
  { href: "/about", label: "About Us" },
  { href: "/team", label: "Our Team" },
  { href: "/events", label: "Events" },
  { href: "/story", label: "Our Story" },
];
